import { z } from 'zod';

export const exerciseSchema = z.object({
  exercise: z.string().min(1, 'Exercise name is required'),
  sets: z.number().int().positive('Sets must be a positive number'),
  reps: z.string().min(1, 'Reps are required'),
  weight: z.number().nonnegative('Weight cannot be negative'),
});

export type ExerciseFormData = z.infer<typeof exerciseSchema>;
